import type { DriveStep } from 'driver.js';

export const adminDashboardTourId = 'admin:dashboard';

export const adminDashboardSteps: DriveStep[] = [
  {
    element: '[data-tour="admin:sidebar"]',
    popover: {
      title: 'Панель администратора',
      description:
        'Панель администратора. Отсюда вы управляете всей платформой: пункты выдачи, заявки на открытие, пользователи.',
    },
  },
  {
    element: '[data-tour="admin:stats"]',
    popover: {
      title: 'Статистика',
      description:
        'Сводная статистика платформы: количество пунктов выдачи, пользователей, заказов и ожидающих заявок.',
    },
  },
  {
    element: '[data-tour="admin:quick-actions"]',
    popover: {
      title: 'Быстрые действия',
      description:
        'Быстрые действия для часто используемых операций.',
    },
  },
  {
    element: '[data-tour="admin:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Кнопка помощи для повторного обучения.',
    },
  },
];
